import React from 'react';
import styles from './additionalResourcesBar.scss';
import { t } from '../../services/i18nService';
import chromeAppService from '../../services/ChromeAppService';
import utilService from '../../services/UtilService';

class ChromeAppResourceBarHomeButton extends React.PureComponent {
    callHideChromeAdditionalResourcesIframe = () => {
        chromeAppService.dispatchHideChromeAppAdditionalResourceIframe();
    }

    onButtonClick = (e) => {
        e.preventDefault();
        this.callHideChromeAdditionalResourcesIframe();
    };

    render() {
        const testTitle = utilService.getTestTitle();

        return (
            <li>
                <button
                    role="link"
                    onClick={this.onButtonClick}
                    className={`${styles.resourceButton} ${styles.chromeAppButton}`}
                    aria-label={t('general.chromeAppResourceBarHomeButton')}
                >
                    <i className="fa fa-home" aria-hidden="true" />
                    {testTitle}
                </button>
            </li>
        );
    }
}

export default ChromeAppResourceBarHomeButton;
